module.exports = __webpack_public_path__ + "a22dc126d21bc6860f1faa0b4a1ed0ec.pdf";